import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import routes from 'constants/routes';
import { CardCaptureForm } from '../CardCaptureForm';

export const ClientPaymentTransaction = (): JSX.Element | null => {
	const history = useHistory();
	const { payment } = useSelector((state: RootState) => state);

	if (payment.orderDataToClient == null) {
		return null;
	}

	return (
		<CardCaptureForm
			orderData={payment.orderDataToClient}
			submitLabel="Pagar"
			onSuccess={() => {
				history.push(routes.payment.thankYouTransaction);
			}}
		/>
	);
};
